import React, { Component } from "react";
import TextField from '@material-ui/core/TextField';
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Button from "components/CustomButtons/Button.jsx";

import { Redirect } from "react-router-dom";
import { authenticate } from "../../baseparking-api/Auth";
import { connect } from "react-redux";
import { setUser, refreshUser } from "../../actions/AuthActions";
import logo from "../../assets/img/logo.svg";

const styles = {
  body: {
    height: '100vh',
    width: '100%',
    backgroundColor: '#2986e4',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    color: 'white',
    flexDirection: 'column',
  },
  loginContainer: {
    width: 'calc(100% - 20px)',
    maxWidth: '480px',
    padding: '40px',
    backgroundColor: 'white',
  },
  logo: {
    width: '100%',
    maxWidth: '300px',
  },
  button: {
    margin: '40px -15px 0 -15px',
    width: '364px',
    bacgrkoundColor: '#2986e4',
  }
}

class Login extends Component {
  constructor() {
    super();
    this.state = {
      username: "",
      password: "",
      redirect: false
    };
  }

  submitLogin(e) {
    e.preventDefault();

    const { username, password } = this.state;
    console.log(username, password);
    authenticate(username, password).then(res => {
      if (res.success === true) {
        console.log(res);
        window.location = "/dashboard";
      }
    });
  }

  render() {
    if (this.state.redirect) return <Redirect to="/" />;
    return (
      <div style={styles.body}>
        <img src={logo} style={styles.logo} />
        <GridContainer>
          <form onSubmit={e => this.submitLogin(e)} style={{ width: "100%" }} style={styles.loginContainer}>
            {/* <GridItem xs={12} sm={12} md={5}> */}
            <TextField
              autoFocus
              margin="dense"
              id="name"
              label="Netfang"
              value={this.state.username}
              onChange={e => this.setState({ username: e.target.value })}
              type="text"
              fullWidth
            />
            {/* </GridItem> */}
            {/* <GridItem xs={12} sm={12} md={3}> */}
            <TextField
              margin="dense"
              id="pass"
              label="Lykilorð"
              value={this.state.password}
              onChange={e => this.setState({ password: e.target.value })}
              type="password"
              fullWidth
            />
            {/* </GridItem> */}
            <GridItem xs={12} sm={12} md={3}>
              <Button style={styles.button} type="submit">Log in</Button>
            </GridItem>
          </form>
        </GridContainer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth
  };
}
function mapDispatchToProps(dispatch) {
  return {
    setUser: user => setUser(user),
    refreshUser: () => refreshUser()
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Login);



// WEBPACK FOOTER //
// ./src/views/Login/Login.jsx